// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/*Temporary fix for integration style in KT1*/\nkt-avatar > img {\n    max-width:inherit !important;  border:none !important;\n}\n\n.mini-admin-logo {\n    max-width: 48px !important;\n}\n\nh3 {\n    font-size:12px !important;\n}", ""]);
// Exports
module.exports = exports;
